import { render, staticRenderFns } from "./DeleteForm.vue?vue&type=template&id=c23e0aee&"
import script from "./DeleteForm.vue?vue&type=script&lang=js&"
export * from "./DeleteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports